import { render, staticRenderFns } from "./ViewControllerConnection.vue?vue&type=template&id=2ad8eedf&"
import script from "./ViewControllerConnection.vue?vue&type=script&lang=js&"
export * from "./ViewControllerConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports